import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
    <p><strong>Description</strong></p>
    <p>This associate is ranked the top 10 defect offenders that have a high number of delivery not received, DNR, units
      that were marked 'Delivered to Houseold Member' or missing a Photo on Delivery when one was required.</p>
    <p><strong>Impact</strong></p>
    <p>
      Delivered not received, DNR, is a direct representation of poor customer experience. By definition, the customer's
      package is marked delivered, but the customer reaches out to Customer Service stating that they never received the
      package. SW DNR is a sub-category of DNR in which these reported missing units were marked 'Delivered to a Household
      Member' or were delivered without a required Photo on Delivery.
    </p>
    <p><strong>Resolution Steps</strong></p>
    <p>1) Complete the STU/Questionnarie</p>
    <p>2) Re-iterate to the driver the importance of marking units delivered with true reason code and to always take a POD
      when prompted</p>
    <p>
      3) Share the Keys for Succesful Delivery SOP with the Driver: <span className="wikiinternallink"><a
      href="https://tiny.amazon.com/da1bh5ik/amazcorpamazsiteAMZLproc_lay">link,</a></span> and provide them with badge card
      if they do not have
      one: <span className="wikiinternallink"><a
      href="https://tiny.amazon.com/6gqy5btm/amazcorpamazsiteALLCProjtrai">link.</a></span>
    </p>
    <p><strong>Supplemental Links</strong></p>
    <p>
      1)
      <span className="wikiinternallink">
            <a
              href="https://us-east-1.quicksight.aws.amazon.com/sn/dashboards/b7f9fd30-55a4-4409-90c9-9a1bd109b603/sheets/b7f9fd30-55a4-4409-90c9-9a1bd109b603_2c2b136d-dc99-44ea-a596-573c9cd26355?directory_alias=amazonbi&amp;qs-signin-user-auth=false#"
            >
                DNR Quicksight
            </a>
        </span>
    </p>
    <div className="wikimodel-emptyline"></div>
    <p><strong>Resolver Input</strong></p>
    <p>1) True or False: If you see someone at the intended address, you should hand the package to them. &nbsp;- True /
      False - you must deliver to doorstep in order to take a photo and maintain a safe distance.</p>
    <p>
      2) True or False: It is okay to bypass the Photo on Delivery if you are running behind in your route - True / False -
      a Photo on Delivery will not be the breaker in your deliver efficiency. Taking a few seconds to take the photo helps
      us and the customer.
    </p>
    <p>3) True or False: An acceptable Photo on Delivery has the package visible and the delivery location is clear. - True
      / False</p>
    <p>4) Does the Driver remember bypassing Photo on Delivery at all last week? If so, why? - Open Text</p>
    <p>5) Does the Driver have any barriers that they would like to share in order to allow us to improve their experience?
      - Open Text</p>
    <p>6) Does the Driver understand the importance of DNR and SW DNR? - Yes / No</p>
    <p>7) Does the Driver have any questions? - Open Text</p>
    <p>8) Status - Closed / Expired / Open / Pending / Work In Progress</p>
  </div>`
);


// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_SWDNR.jsx